/*! @azure/msal-browser v2.31.0 2022-11-07 */
'use strict';
import { __extends } from '../_virtual/_tslib.js';
import { AuthorizationCodeClient } from '@azure/msal-common';

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var HybridSpaAuthorizationCodeClient = /** @class */ (function (_super) {
    __extends(HybridSpaAuthorizationCodeClient, _super);
    function HybridSpaAuthorizationCodeClient(config) {
        var _this = _super.call(this, config) || this;
        _this.includeRedirectUri = false;
        return _this;
    }
    return HybridSpaAuthorizationCodeClient;
}(AuthorizationCodeClient));

export { HybridSpaAuthorizationCodeClient };
//# sourceMappingURL=HybridSpaAuthorizationCodeClient.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@azure/msal-browser/dist/interaction_client/HybridSpaAuthorizationCodeClient.js
// module id = 334
// module chunks = 0